module.exports = __webpack_public_path__ + "static/img/icon_about_logo.16b6b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_about_logo.png
// module id = qGiW
// module chunks = 1